import React from 'react';
import SingleCarousel from 'components_newui/SingleCarousel/View'
import ChallengeInfoPanel from './ChallengeInfoPanel';
import defaultImg from 'img/hero_image.png';

const ChallengeMediaPanel = ({
  challenge,
  classes,
  showDetails,
  expiresImg,
  visitImg,
  taggedImg,
  pendingImg,
  sponsorName,
  proposerEmail,
  proposerNameNotAvailable,
  proposedDate,
  starts,
  ends,
  challengeCreateDate,
  // endDate,
  visits,
  numIdeas,
  formatDate,
  navigateToUserProfile,
}) => {
  console.log("details challenge==>", challenge,challenge?.images[0]?.url)
  return (
    <div className={classes.imageInfoPanel}>
      <div className={classes.imagePanel}>
       

            <img
              src={ challenge?.image?.url || challenge?.images[0]?.url || challenge?.mainPhoto || defaultImg}

              className={classes.images}
              alt="thumbnail"
            />
      </div>

      <div style={{ flexGrow: 1, position: 'relative' }}>
        <ChallengeInfoPanel
          challenge={challenge}
          classes={classes}
          showDetails={showDetails}
          expiresImg={expiresImg}
          visitImg={visitImg}
          taggedImg={taggedImg}
          pendingImg={pendingImg}
          sponsorName={sponsorName}
          proposerEmail={proposerEmail}
          proposerNameNotAvailable={proposerNameNotAvailable}
          proposedDate={proposedDate}
           challengeCreateDate={challengeCreateDate}
          starts={starts}
          ends={ends}
          // endDate={endDate}
          visits={visits}
          numIdeas={numIdeas}
          formatDate={formatDate}
          navigateToUserProfile={navigateToUserProfile}
        />
      </div>
    </div>
  );
};

export default ChallengeMediaPanel;
